<template>
    <div class="container-fluid">
        <div class="herosection">
            <NavbarSection />
            <div class="overlay-img"></div>
            <div class="heroWriteup">
                <h2>Media Gallery</h2>
                <p>
                    Explore moments from our tournaments, events, and everyday club life
                    captured in photos and videos that showcase the spirit of LLTC.
                </p>
            </div>
        </div>

        <!-- Main Content -->
        <div class="content-wrapper">
            <!-- Left: Gallery -->
            <div class="gallery-section">
                <AllMediaGallery />
            </div>

            <!-- Right: Archives -->
            <aside class="archive-section">
                <h4>Archives</h4>
                <div class="all-media"><a href="/all-media">All Media</a></div>
                <div v-for="(item, index) in archives"
                        :key="index"
                        class="archive-item"
                        @click="goToArchive(item)"
                        style="cursor: pointer;"
                        >
                     
                        {{ item.archive_date }}
                    
                </div>
            </aside>
        </div>

        <FooterSection />
    </div>
</template>

<script setup>
/* eslint-disable */
import FooterSection from '@/components/FooterSection.vue';
import HighLights from '@/components/HighLights.vue';
import AllMediaGallery from '@/components/AllMediaGallery.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import ProgramOverview from '@/components/ProgramOverview.vue';
import SocialEvents from '@/components/SocialEvents.vue';
import SocialFeed from '@/components/SocialFeed.vue';
import SportSections from '@/components/SportSections.vue';
import router from '@/router';
import { ArrowRight, Bookmark, MoveUpRight } from "lucide-vue-next"
import { ref, computed, onMounted, onUnmounted, onBeforeUnmount, nextTick } from "vue";
import axios from 'axios';
import { useRoute } from 'vue-router'

const route = useRoute()

let base_url = process.env.VUE_APP_BASE_LIVE_URL
const dataList = ref([]);
const dataId = ref('')
const archives = ref([])
// Action methods
const listArchives = async () => {
  try {
    const response = await axios.get(`/media_gallery_archives.php`);
    archives.value = response.data.data; 
  } catch (error) {
    console.error(error.message);
  }
};
const goToArchive = (item) => {
  router.push({
    name: 'AllMediaPage',
    query: {
      archive: item.archive_date
    }
  });
};

onMounted( async () => {
    dataId.value = route.params.date
    await listArchives();
});

onUnmounted(() => {

});

onBeforeUnmount( async () => {
  
});

</script>

<style lang="scss" scoped>
.content-wrapper {
    display: flex;
    width: 100%;
    //gap: 24px;
    //padding: 30px;
}

/* Gallery */
.gallery-section {
    width: 100%;
    padding: 20px;
}

/* Archives */
.archive-section {
    flex: 1;
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    margin-top: 80px;
    margin-left: 10px;
}

.archive-section h4 {
    margin-bottom: 12px;
    font-size: 12px;
    font-family: Comic Sans MS;
    font-weight: bold;
    text-align: left !important;
}

.archive-list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.all-media{

    a{
        color: #000000;
        font-size: 12px;
        font-family: Comic Sans MS;
        text-decoration: underline;
        text-align: left;
    }
}
.archive-item {
    font-size: 12px;
    font-family: Comic Sans MS;
    text-decoration: underline;
    text-align: left;
}

.archive-list button {
    background: none;
    border: none;
    padding: 2px 0;
    cursor: pointer;
    color: #0d6efd;
    font-size: 14px;
}

.archive-list button:hover {
    text-decoration: underline;
}

/* Mobile */
@media (max-width: 768px) {
    .content-wrapper {
        flex-direction: column;
    }
}

.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/media_gallery/media.png');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
}

/* Dark overlay */
.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Adjust opacity for darkness */
    z-index: 1;
    /* sits above images but below content */
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    background: linear-gradient(180deg, rgba(9, 73, 35, 0) 0%, #01170A 100%);
}

.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}


.heroWriteup {
    position: absolute;
    max-width: 650px;
    text-align: center;
    bottom: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    color: white;

    h2 {
        font-size: 45px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;

    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #7c7777;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 15px 25px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }
}

/* Arrow buttons */
.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  border: none;
  font-size: 36px;
  padding: 0px 16px;
  cursor: pointer;
  z-index: 10;
  border-radius: 50%;
}

.nav-arrow.left {
  left: 30px;
}

.nav-arrow.right {
  right: 30px;
}

.nav-arrow:hover {
  background: rgba(0, 0, 0, 0.7);
}

/* Text animation */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(25px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-25px);
}

/* Dots */
.hero-dots {
  position: absolute;
  bottom: 40px;
  left: 80px;
  display: flex;
  gap: 10px;
}

.hero-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
}

.hero-dots span.active {
  background: #fff;
}




.authbuttons {
    display: flex;
    gap: 1rem;

    .login {
        background-color: #2A5237;
        border: 0px solid #0000001f;
        color: #fff;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 5px 20px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .login:hover {
        border: 2px solid #ed4e24;
    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #0000001f;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 10px 20px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .register:hover {
        background-color: #c63d1c;
    }
}

.become-member {
    background-color: #094923;
    max-width: 80%;
    margin: auto;
    margin-top: 5rem;
    border-radius: 24px;
    padding: 20px;
    height: 479px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;

    .bgelement-right {
        position: absolute;
        top: 0;
        right: 0;
    }

    .bgelement-left {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    h2 {
        font-size: 26px;
        color: #fff;
        font-weight: 500;
        margin: 2rem 0;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        color: #fff;
        font-weight: 300;
        max-width: 569px;
        /* margin: 2rem 0; */
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #FFFFFF29;
        border: 1px solid white;
        padding: 10px 20px;
        border-radius: 30px;
        color: white;
        gap: 10px;
        margin-top: 1rem;

        p {
            color: white;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            cursor: pointer;
            transition: 0.3s ease;
            padding: 0%;
            margin: 0%;
        }
    }
}

.stay-connected {
    position: relative;
    height: 495px;
    padding-top: 100px;
}

.stay-connected .bg-img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: -1;
}

.stay-connected .bg-img img {
    width: 100%;
    height: auto;
    display: block;
}

.stay-connected h2 {
    font-size: 36px;
    color: #000000;
    font-weight: 500;
    margin: auto;
    font-family: "Open Runde", sans-serif;
    text-align: center;
    max-width: 600px;
}

.stay-connected p {
    font-size: 16px;
    color: #555555;
    font-weight: 400;
    max-width: 681px;
    margin: auto;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}

.subscribe-form {
    background-color: #fff;
    border: 1px solid #ED4E242E;
    width: 418px;
    height: 50px;
    border-radius: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
    padding-right: 4px;
    margin: auto;
    margin-top: 20px;

    input {
        border: none;
        outline: none;
        width: 100%;
        height: 100%;
        border-radius: 30px;
        padding-left: 8px;
        font-size: 16px;
    }

    button {
        background-color: #ED4E24;
        color: white;
        padding: 10px 20px;
        border-radius: 30px;
        border: none;
    }
}


@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

        .heroWriteup {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            color: white;
            padding:0 0 0 0rem;

            h2 {
                font-size: 32px;
                /* shrink a bit for small screens */
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                font-size: 16px;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
                padding: 1.2rem;
            }
        }

        .authbuttons {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .login {
                background-color: #2A5237;
                border: 0px solid #0000001f;
                color: #ffffff;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .login:hover {
                border: 2px solid #ed4e24;
            }

            .register {
                background-color: #ed4e24;
                border: 2px solid #0000001f;
                color: white;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .register:hover {
                background-color: #c63d1c;
            }
        }

    }

    .become-member {
        background-color: #094923;
        max-width: 100%;
        margin: auto;
        margin-top: 5rem;
        border-radius: 24px;
        padding: 20px;
        height: 479px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        h2 {
            font-size: 26px;
            color: #fff;
            font-weight: 500;
            margin: 2rem 0;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 16px;
            color: #fff;
            font-weight: 300;
            max-width: 100%;
            /* margin: 2rem 0; */
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }
    }

    .stay-connected {
        position: relative;
        height: auto;
        padding-top: 20px;
    }

    .subscribe-form {
        max-width: 100%;
    }
}
</style>
